import store from '@/store'

export default async (to, from, next) => {
  const user = store.getters['auth/user']

  if (store.getters['auth/check'] && user) {
    next({ name: `${user.role}.dashboard` })
  } else {
    next()
  }
}
